import axios from "axios";
import { CommonPathWay } from "../../Components/CommonPathWay";
const BASE_URL = `${process.env.REACT_APP_EXPERIAN_API}`;
const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
export async function commonAxios(
  url,
  method = "GET",
  params = {},
  data = {},
  headers = {}
) {
  try {
    const response = await CommonPathWay(
      `/experian${url}`,
      method.toUpperCase(),
      params,
      data,
      headers
    );
    console.log(response,"Got in data for response")
    return response;
  } catch (error) {
    throw error;
  }
};
export const formDataAxios = async (
  url,
  method = "POST",
  data,
  header = {}
) => {
  try {
    const response = await instance({
      url,
      method: method.toUpperCase(),
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        ...header,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default commonAxios;
